import { useOnlineStatus } from '../context/OnlineStatusContext'

export default function OnlineDot({ userId, size = 10, fallback = false }) {
  const { isOnline } = useOnlineStatus()
  if (!userId) return null
  if (!isOnline(userId) && !fallback) return null
  return (
    <span
      style={{
        position: 'absolute',
        bottom: 0,
        right: 0,
        width: size,
        height: size,
        borderRadius: '50%',
        background: '#22c55e',
        border: '2px solid var(--surface, #fff)',
        display: 'block',
      }}
      title="Online"
    />
  )
}
